import {Component, OnDestroy, OnInit} from '@angular/core';
import {AssignmentService} from '../services/AssignmentService';
import {FormService} from '../services/FormService';
import {ChainBranchSelector} from './chain-branch-selector';
import {AssignmentsPositions} from './assignments-positions';
import {AssignmentsApprovers} from './assignments-approvers';
import {AssignmentsSchedule} from './assignments-schedule';
import {AssignmentsDisplayFields} from './assignments-display-fields';
import {Subscription} from 'rxjs';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {Message} from 'primeng/message';
import {Button} from 'primeng/button';

declare var Yii: any;

@Component({
  selector: 'ng-edit-assignments-tab',
  templateUrl: './assignments-tab.html',
  imports: [
    ChainBranchSelector,
    AssignmentsPositions,
    AssignmentsApprovers,
    AssignmentsSchedule,
    AssignmentsDisplayFields,
    Tab,
    TabList,
    Tabs,
    TabPanel,
    TabPanels,
    Message,
    Button
  ]
})
export class AssignmentsTab implements OnInit, OnDestroy {

  Yii = Yii;

  public currentTab = "positions";

  private subs: Subscription[] = [];

  constructor(
    public asvc: AssignmentService,
    public fsvc: FormService,
  ) {
    this.subs.push(
      this.asvc.OnChainAssigned.subscribe({
        next: () => {
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
  }

  t(category: string, message: string): string {
    return this.Yii.t(category, message);
  }
}
